
import React, { useState, useEffect, useRef } from 'react';
import './Dashboard.css';
import ThumbnailWithActions from './ThumbnailWithActions';
import FileUpload from './FileUpload';
import Util from './ait/Util.js';
import Swal from 'sweetalert2';
import {invalidateImageCache} from './ait/Funcs.js';


const Dashboard = ({ auth, onLogout, onAuth }) => {
  const [selectedResource, setSelectedResource] = useState(null);
  const [isWaitingForResponse, setIsWaitingForResponse] = useState(false);
  const [resources, setResources] = useState([]);
  const [showMenu, setShowMenu] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
  const [selectedItem, setSelectedItem] = useState(null);
  const [longPressTriggered, setLongPressTriggered] = useState(false);
  const [aitText, setAitText]=useState("");
  const [loadingAction, setLoadingAction] = useState(null);
  const [error,setError]= useState("");

  const menuRef = useRef(null); // Reference for context menu
  const dashboardRef = useRef(null); // Reference for the entire dashboard area
  const pressTimerRef = useRef(null); // Ref to store the timer
  
  const LONG_PRESS_THRESHOLD = 1000; // Threshold time for long press (1 second)


  const fetchWithAuth = async (url, options = {}) => {
    const response = await fetch(url, {
      ...options,
      credentials: "include", // Send cookies/session
    });
  
    if (response.status === 401 || response.status === 403) {
      console.warn("JWT invalid or expired. Logging out...");
      onLogout(); // <-- your logout function
      throw new Error("Unauthorized");
    }
  
    return response;
  };
  

  // Handle clicking outside of context menu
  const handleClickOutside = (event) => {

    if (
      menuRef.current && !menuRef.current.contains(event.target) 
    ) {
      setShowMenu(false);  // Close the context menu
      console.log("Triggered hide");
    }
    console.log('leaving outside click')
  };

  // Register the mousedown event listener
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  const getAit = async (fileName) =>
  {
     const command = Util.serverName + "/protected/getAit";
     
       const response = await fetchWithAuth(command, {
         method: 'POST',
         headers: { 'Content-Type': 'application/json' },
         body: JSON.stringify({fileName:fileName}),
       });
 
       const data = await response.json();
 
       if (!response.ok) {          
         return null;
       }
 
       if (!data.status) {
         return null;
       }
       setAitText(data.data);

       return data.data;
  };

  const handleResourceClick = (resource) => {

    if(resource.type === 'ait')
    {
      console.log("FileName: ", resource.name);

      getAit(resource.name);
      console.log("Get Text of AIT");
    }

    setSelectedItem(resource);
    setSelectedResource(resource);
    setShowMenu(false);
    setLongPressTriggered(false); // Reset long press state on normal click
  };

  const handleContextMenu = (e, resource) => {
    e.preventDefault(); // Prevent default right-click behavior
    const yOffset = window.scrollY; // Get the current scroll position on the Y axis
    setSelectedItem(resource);
    setMenuPosition({ x: e.clientX, y: e.clientY + yOffset }); // Add scroll position to Y value
    setShowMenu(true); // Show context menu on right-click    
    setSelectedResource(resource);
  };
  
  const handleReload = (flag, data) => {

    if(flag==true)
    {
      let fileArray = data.files;      

      let resourceArray = [];
      let u = Util.getInstance();
      let webId = data.user.webId;

      fileArray.forEach((resource) => {
        if (u.getImageTypeFromFilename(resource) !== "Unknown") {
          let url = `https://myaiweb.ca/${webId}/${resource}`
          url = url + "?v="  + new Date().getTime();
          let resourceType = { type: 'image', name: resource, url: url };
          resourceArray.push(resourceType);
        }
        if (u.isHtmlFile(resource)) {
          let url = `https://myaiweb.ca/${webId}/${resource}`
          url = url + "?v="  + new Date().getTime();
          let resourceType = { type: 'html', name: resource, url: url };
          resourceArray.push(resourceType);
        }
        if (u.isAitFile(resource)) {
          let url = `https://myaiweb.ca/${webId}/${resource}`
          url = url + "?v="  + new Date().getTime();
          let resourceType = { type: 'ait', name: resource, url: url };
          resourceArray.push(resourceType);
        }

      });
      setResources(resourceArray);
    }    
  };

  const handleDelete = async () => {
    console.log(`Delete ${selectedItem.name}`);
    setShowMenu(false);

    const deleteResource = async () => {
      setIsWaitingForResponse(true);
            
      const command = Util.serverName + "/protected/deleteResource";
      try {
        const response = await fetchWithAuth(command, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({fileName:selectedItem.name}),
        });

        const data = await response.json();

        if (!response.ok) {
          setIsWaitingForResponse(false);
          return;
        }

        if (!data.status) {
          setIsWaitingForResponse(false);
          return;
        }

        invalidateImageCache(selectedItem.name, auth.user.webId, false);
        window.location.reload();
        /*
        let fileArray = data.files;
        let resourceArray = [];
        let u = Util.getInstance();
        let webId = auth.user.webId;

        fileArray.forEach((resource) => {
          if (u.getImageTypeFromFilename(resource) !== "Unknown") {
            let url = `https://myaiweb.ca/${webId}/${resource}`
            // url = url + "?v="  + new Date().getTime(); 
            let resourceType = { type: 'image', name: resource, url: url };
            resourceArray.push(resourceType);
          }
          if (u.isHtmlFile(resource)) {
            let url = `https://myaiweb.ca/${webId}/${resource}`
            url = url + "?v="  + new Date().getTime();             
            let resourceType = { type: 'html', name: resource, url: url };
            resourceArray.push(resourceType);
          }
          if (u.isAitFile(resource)) {
            let url = `https://myaiweb.ca/${webId}/${resource}`
            url = url + "?v="  + new Date().getTime();
            let resourceType = { type: 'ait', name: resource, url: url };
            resourceArray.push(resourceType);
          }
  
        });

        let filename=localStorage.getItem('monaco_filename');
        if (filename === selectedItem.name)
        {
          localStorage.setItem('monaco_filename',"");
        }

  
        setResources(resourceArray);
        setIsWaitingForResponse(false);
        setSelectedResource(null);
        */
      } catch (error) {
        console.log("Error thrown");
      }
    };

    Swal.fire({
      title: 'Warning!',
      text: `Are you sure you want to delete ${selectedItem.name}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Proceed',
      cancelButtonText: 'Cancel',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        // Your logic for proceeding with the action (e.g., file deletion)
        console.log('User confirmed the action');
        deleteResource()
      } else {
        // Logic for canceling the action
        console.log('User canceled the action');
      }
    });

  };

  const handleDownload = async () =>
  {
    const command = Util.serverName + "/protected/downloadFile";

      setIsWaitingForResponse(true);
      
      try {
        const response = await fetchWithAuth(command, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ fileName: selectedItem.name }),
        });

        if (!response.ok) {
          setIsWaitingForResponse(false);
          return;
        }

        const blob = await response.blob();

        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = selectedItem.name;
        document.body.appendChild(a);
        a.click();

        a.remove();
        window.URL.revokeObjectURL(url);

        setIsWaitingForResponse(false);
        setSelectedResource(null);

      } catch (err) {
        console.log(err);
        setIsWaitingForResponse(false);
      }      
  }

  const renameFunc = async(prefix,op,to) =>
  {
    console.log(`renameFunc ${selectedItem.name}`);    
    console.log("op: ", op);
    setShowMenu(false);  
    
    setIsWaitingForResponse(true);
    const command = Util.serverName + "/protected/renameFile";
    try {
        const response = await fetchWithAuth(command, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({fileName:selectedItem.name, prefix:prefix, op:op, to:to}),
        });

      const data = await response.json();

      if (!response.ok) {
        setIsWaitingForResponse(false);
        throw new Error(data.message || `Operation Failed: (${response.status}`);

      }

      if (!data.status) {
        setIsWaitingForResponse(false);
        throw new Error(data.message || "Operation failed");
        
      }

      let fileArray = data.files;
      let resourceArray = [];
      let u = Util.getInstance();
      let webId = auth.user.webId;

      fileArray.forEach((resource) => {
        if (u.getImageTypeFromFilename(resource) !== "Unknown") {
          let url = `https://myaiweb.ca/${webId}/${resource}`
          // url = url + "?v="  + new Date().getTime(); 
          let resourceType = { type: 'image', name: resource, url: url };
          resourceArray.push(resourceType);
        }
        if (u.isHtmlFile(resource)) {
          let url = `https://myaiweb.ca/${webId}/${resource}`
          url = url + "?v="  + new Date().getTime(); 
          let resourceType = { type: 'html', name: resource, url: url };
          resourceArray.push(resourceType);
        }
        if (u.isAitFile(resource)) {
          let url = `https://myaiweb.ca/${webId}/${resource}`
          url = url + "?v="  + new Date().getTime();
          let resourceType = { type: 'ait', name: resource, url: url };
          resourceArray.push(resourceType);
        }

      });

      let newAuth = {authenticated:true, user:data.user, globals:data.globals};
      onAuth(newAuth);
      setResources(resourceArray);
      setIsWaitingForResponse(false);
      setSelectedResource(null);
    } 
    catch (error) 
    {
        console.log("Error thrown");
        Swal.fire({
          icon: 'error',
          title: 'Operation Failed',
          text: error.message || 'File Operation Failed'
        });

    }      
  }

  

  async function getPullDestination(fType) {

    let files=[];
    resources.forEach((resource) => {
      if(resource.type==='html')
      {
        if(fType==="index")
        {
          const regex1 = /^(?:[a-zA-Z0-9]+_)?i\d+\.html$/;
          if(regex1.test(resource.name)==true)
          {
            if(selectedItem.name !== resource.name)
            {
              files.push(resource.name);
            }
          }
        }
      }
    });

    // Generate a list of options for the combo box
    const fileOptions = files.map(file => ({
          text: file,
          value: file
    }));
    
    // Add 'None' as an option at the beginning


    if(fType==="index")
    {
      if(selectedItem.name !== "index.html")
      {
       fileOptions.unshift({ text: 'index.html', value: 'index.html' });
      }

    }
    else
    {
      if(selectedItem.name !== "form.html")
      {
        fileOptions.unshift({ text: 'form.html', value: 'form.html' });
      }
    }

    fileOptions.unshift({ text: 'None', value: 'none' });

    // Display SweetAlert2 with a combo box and buttons
    const { value, isConfirmed } = await Swal.fire({
      title: 'Select File to Overwrite', // Change the title to better reflect single selection
      input: 'select', // The type of input is a dropdown
      inputOptions: fileOptions.reduce((options, file) => {
        options[file.value] = file.text;
        return options;
      }, {}),
      inputPlaceholder: 'Select a file...',
      showCancelButton: true,
      confirmButtonText: 'Proceed',
      cancelButtonText: 'Cancel',
      inputValidator: (value) => {
        if (!value) {
          return 'You must select a file!';
        }
      }
    });

    // If confirmed and a valid file is selected, proceed
    if (isConfirmed) {
      if (value === 'none') {
        console.log('No files selected. Proceeding with no files.');
        await renameFunc(selectedItem.name, "pull", undefined);      
        // Handle the 'none' selection if needed
      } else {
        console.log(`Proceeding with selected file: ${value}`);
        await renameFunc(selectedItem.name, "pull", `${value}`);      
        // Handle the selected file here (e.g., pulling the file or moving to the next stage)
      }
    } else {
      console.log('Action canceled.');
    }
  }

  const getPrefixForHtml = async () => {
    const result = await Swal.fire({
      title: 'Enter New Filename',
      input: 'text',
      inputPlaceholder: 'Enter',
      showCancelButton: true,
      confirmButtonText: 'Proceed',
      cancelButtonText: 'Cancel',
      focusCancel: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      inputValidator: async (value) => {
        console.log("input validator");
        let ut = Util.getInstance();
        let rt = await ut.checkPrefix(value);
        if (rt === false) {
          console.log("CheckPrefix is false");
          return "Prefix is not valid";
        }
        if(value=="")
        {
          return "Prefix must have a value";
        }
        return null;
      }
    });

    if (result.isConfirmed) {
      console.log('User entered:', result.value);
      renameFunc(result.value, "prefix", undefined);
      return result.value;
    } else if (result.isDismissed) {
      console.log('User canceled the operation');
      return null;
    }
  }
  
  async function getPrefixForImg() {
    const result = await Swal.fire({
      title: 'Enter a prefix',
      input: 'text', // This sets up an input field for number entry
      inputPlaceholder: 'Enter a number',
      showCancelButton: true,  // Shows the Cancel button
      confirmButtonText: 'Proceed', // Custom text for the Proceed button
      cancelButtonText: 'Cancel',  // Custom text for the Cancel button
      focusCancel: true,  // Focuses on the Cancel button by default (optional)
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,    

      inputValidator: async (value) => {

        console.log("input validator");
        let ut = Util.getInstance();
        let rt = await ut.checkPrefix(value);
        if (rt==false)
        {        
          console.log("CheckPrefixs is false");
          return "Prefix is not valid"
          
        }
        return null; // No error
      }
    })
  
    if (result.isConfirmed) {
      // Proceed with the operation using result.value, which is the number entered
      console.log('User entered:', result.value);
      renameFunc(result.value, "prefix", undefined);      
      // You can perform your operation here
      return result.value; // Return the number for further processing
    } else if (result.isDismissed) {
      // Handle the cancel operation here
      console.log('User canceled the operation');
      return null; // You can return a specific value or null when canceled
    }
  }
  
  const handleDuplicate = async () => 
  {
    await renameFunc(selectedItem.name, "pull", undefined);
  }

    
  const handleRename = async () => {
    console.log(`Rename ${selectedItem.name}`);
    setShowMenu(false);

    let filename = selectedItem.name;
    if (filename.toLowerCase().endsWith('.html')) 
    {
      await getPrefixForHtml();
    }
    else
    {
      await getPrefixForImg();
    }
    
  };


  const handlePublishWebsite = async () => 
  {
    
      try {
        setError("");
        setLoadingAction("publish");
    
        // Your existing code...
       await publishWebsite();
    
      } finally {
       setLoadingAction(null);
      }
  }


  const handleUnpublishWebsite = async () => {
    try {
      setError("");
      setLoadingAction("unpublish");
  
      // Your existing code...
     await unpublishWebsite();
  
    } finally {
      setLoadingAction(null);
    }
  }


  const publishWebsite = async () =>
  {

      const command = Util.serverName + "/protected/publishWebsite"; // Base API endpoint
      const response = await fetchWithAuth(command, {
        method: 'POST', // Use POST method
        headers: { 'Content-Type': 'application/json' }, // Specify JSON format
        body: JSON.stringify({}), // JSON payload
        
      });

      const data = await response.json(); // Parse the JSON response

      if (!response.ok) {
        // Handle HTTP errors
        // console.log("Response: "+response.message);
        // console.log("ResponseData: "+data.message);
        // throw new Error(data.msg || 'Something went wrong');
        setError("Response Error");

        return;
      }

      if (!data.status) {
        // Handle application-specific errors (e.g., if `status` is false)
        // setError(error.message);
        console.log("Response Error");
        setError("Unable to Publish Website");
        return;
        // throw new Error(data.msg);
      }

      // clipMessages(updatedMessages);
      // clipMessages(updatedMessages);
      console.log("success");    
  }

  const unpublishWebsite = async () =>
  {

      const command = Util.serverName + "/protected/unpublishWebsite"; // Base API endpoint
      const response = await fetchWithAuth(command, {
        method: 'POST', // Use POST method
        headers: { 'Content-Type': 'application/json' }, // Specify JSON format
        body: JSON.stringify({}), // JSON payload
        
      });

      const data = await response.json(); // Parse the JSON response

      if (!response.ok) {
        // Handle HTTP errors
        // console.log("Response: "+response.message);
        // console.log("ResponseData: "+data.message);
        // throw new Error(data.msg || 'Something went wrong');
        setError("Response Error");

        return;
      }

      if (!data.status) {
        // Handle application-specific errors (e.g., if `status` is false)
        // setError(error.message);
        console.log("Response Error");
        setError("Unable to Publish Website");
        return;
        // throw new Error(data.msg);
      }

      // clipMessages(updatedMessages);
      // clipMessages(updatedMessages);
      console.log("success");    
  }


  const handleEdit = () => {
    console.log(`Edit ${selectedItem.name}`);
    setShowMenu(false);
  };

  const handleSave = () => {
    console.log(`Save ${selectedItem.name}`);
    setShowMenu(false);
  };

  const handlePull = async () => {
    console.log(`Rename ${selectedItem.name}`);

    // Example usage with a list of files
    // const availableFiles = ['file1.txt', 'file2.txt', 'file3.txt'];
    // await getPullDestination(availableFiles);

    let fileType="form";
    const regex1 = /^(?:[a-zA-Z0-9]+_)?i\d+\.html$/;
    if(regex1.test(selectedItem.name)==true ||
      selectedItem.name==="index.html")
    {
      fileType="index"
    }

    await getPullDestination(fileType);
    
    setShowMenu(false);

    // await renameFunc(selectedItem.name, "pull");      
  };

  const handlePush = async () => {
    console.log(`Rename ${selectedItem.name}`);
    setShowMenu(false);

    await renameFunc(selectedItem.name, "push", undefined);      
  };


   // Long press detection handlers
   const handleMouseDown = (e, resource) => {
    // Start the long press timer
    pressTimerRef.current = setTimeout(() => {
      setLongPressTriggered(true); // Trigger long press action
      handleContextMenu(e, resource); // Show context menu on long press    
      setSelectedResource(resource);
    }, LONG_PRESS_THRESHOLD);
  };

  const handleMouseUp = () => {
    // Clear the timer if the mouse is released before the threshold
    if (pressTimerRef.current) {
      clearTimeout(pressTimerRef.current);
      pressTimerRef.current = null;
    }
    // If long press was not triggered, handle as a normal click
    if (!longPressTriggered) {
      // setShowMenu(false);
    }
    setLongPressTriggered(false); // Reset long press state
  };

  const handleMouseLeave = () => {
    // Clear the timer if the mouse leaves the element before the threshold
    if (pressTimerRef.current) {
      clearTimeout(pressTimerRef.current);
      pressTimerRef.current = null;
    }
    setLongPressTriggered(false); // Reset long press state if mouse leaves
  };


  useEffect(() => {
    const getResources = async () => {
      setIsWaitingForResponse(true);
      const command = Util.serverName + "/protected/getUserDirList";
      try {
        const response = await fetchWithAuth(command, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({}),
        });

        const data = await response.json();

        if (!response.ok) {
          setIsWaitingForResponse(false);
          return;
        }

        if (!data.status) {
          setIsWaitingForResponse(false);
          return;
        }

        let fileArray = data.files;
        let resourceArray = [];
        let u = Util.getInstance();
        let webId = auth.user.webId;

        fileArray.forEach((resource) => {
          if (u.getImageTypeFromFilename(resource) !== "Unknown") {
            let url = `https://myaiweb.ca/${webId}/${resource}`
            // url = url + "?v="  + new Date().getTime(); 
            let resourceType = { type: 'image', name: resource, url: url };
            resourceArray.push(resourceType);
          }
          if (u.isHtmlFile(resource)) {
            let url = `https://myaiweb.ca/${webId}/${resource}`
            url = url + "?v="  + new Date().getTime(); 
            let resourceType = { type: 'html', name: resource, url: url };
            resourceArray.push(resourceType);
          }
          if (u.isAitFile(resource)) {
            let url = `https://myaiweb.ca/${webId}/${resource}`
            url = url + "?v="  + new Date().getTime();
            let resourceType = { type: 'ait', name: resource, url: url };
            resourceArray.push(resourceType);
          }
  
        });

        setResources(resourceArray);
        setIsWaitingForResponse(false);
      } catch (error) {
        console.log("Error thrown");
      }
    };

    getResources();
  }, []);

  const renderContextMenuContent = () => {
    if (!selectedResource) return null;
    if(selectedResource.type === 'image')
    {
      return (
        <ul>
          <li onClick={handleRename}>Prefix</li>
          <li onClick={handleDelete}>Delete</li>      
          <li onClick={handleDownload}>Download</li>      
        </ul>
      )
    }
    if (selectedResource.type === 'html' || selectedResource.type === 'ait') 
    {

      /*
      let show=true;
      if(selectedResource.name === auth.user.workingHtml)
      {
        show=false;
      }
      */

      return (
        <ul>
          <li onClick={handleDuplicate}>Duplicate</li>
          <li onClick={handleRename}>Rename</li>
          {/*show &&(<li onClick={handlePush}>Set As Working</li>) */}          
         {/* <li onClick={handleMove}>Move To Template</li> */}
          <li onClick={handleDelete}>Delete</li>
          <li onClick={handleDownload}>Download</li>
        </ul>
      )
    }
  }

  const renderResourceContent = () => {
    if (!selectedResource) return null;

    if (selectedResource.type === 'image') {
      return (
      
          <div className="resource-display">
              <img src={selectedResource.url} alt={selectedResource.name} className="resource-image" />;
          </div>);              
    }

    if (selectedResource.type === 'html') {
      return (
        <div className="resource-display">
            <iframe src={selectedResource.url} title="HTML Viewer" className="html-frame"></iframe>
        </div>
      );
    }

    if (selectedResource.type === 'ait') 
    {
      return (
        <div className="resource-display">
            <pre className="ait-text">{aitText}</pre>
        </div>            
            );
    }
  };

  
  let draftUrl = `https://myaiweb.ca/${auth.user.webId}`
  draftUrl = draftUrl + "?v="  + new Date().getTime();

  let pubUrl = `https://popsite.ca/${auth.user.webId}`
  pubUrl = pubUrl + "?v="  + new Date().getTime();


  return (
    <div className="dashboard-container" ref={dashboardRef}>

      <div className="dashboard-intro">
    
      <h2>Dashboard</h2>
      <p className="dashboard-hint">
          Right-click an image for file options.
      </p>

      <div className="upload-row">
        <div className = "link-container">
          <h3>Your Site Links</h3>
          <p>
            <a 
              href={pubUrl }
              target="_blank"
              rel="noopener noreferrer"
            >
              Published Site
            </a>
          </p>
          <p>
            <a 
              href={draftUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              Draft Site
            </a>
          </p>
          <div className = "button-row">
            <button className ="elegant-button"
                  onClick={handlePublishWebsite}
                  disabled={loadingAction === "publish"}
            >
              {loadingAction === "publish" ? (
                <>
                  <span className="spinner"></span>
                  Publishing...
                </>
              ) : (
                "Publish Changes"
              )}
            </button>
            <button className ="elegant-button"
                  onClick={handleUnpublishWebsite}
                  disabled={loadingAction === "unpublish"}
            >
              {loadingAction === "unpublish" ? (
                <>
                  <span className="spinner"></span>
                  Unublishing...
                </>
              ) : (
                "Unpublish"
              )}
            </button>
          </div>
          {error !== "" && (
              <div className="button-error">
                {error}
              </div>
            )}
        </div>
        <FileUpload
          onUploaded={handleReload}
          uploadType="dashboard"
          onLogout={onLogout}
          closeModal={() => {}}
        />

        <FileUpload
          onUploaded={handleReload}
          uploadType="template"
          onLogout={onLogout}
          closeModal={() => {}}
        />
      </div>

      <div className="dashboard-lower-section">
        {/* whatever comes below */}
      </div>

      </div>

      <div className="dashboard-content">
        {isWaitingForResponse ? (
          <div className="spinner-container">
            <div className="spinner"></div>
          </div>
        ) : (
          <div className="thumbnails-list">
            {resources.map((resource, index) => (
              <div
                key={index}
                className="thumbnail-item"
                onClick={() => handleResourceClick(resource)}
                onContextMenu={(e) => handleContextMenu(e, resource)} // Right-click to show context menu
                onMouseDown={(e) => handleMouseDown(e, resource)} // Detect long press on mouse down
                onMouseUp={handleMouseUp} // Clear timer on mouse up
                onMouseLeave={handleMouseLeave} // Clear timer if mouse leaves the element
              >              
                <ThumbnailWithActions
                  type={resource.type}
                  name={resource.name}
                  url={resource.url}
                  imageClass="thumbnail-image"
                  auth={auth}
                  tType="dashboard"
                />
              </div>
            ))}
          </div>
        )}
        {renderResourceContent()}

      </div>

      {/* Context Menu */}
      {showMenu && (
        <div
          className="context-menu"
          style={{
            top: `${menuPosition.y}px`,
            left: `${menuPosition.x}px`,
            position: 'absolute',
            zIndex: 9999,  // Ensure the context menu is on top
          }}
          ref={menuRef}
        >
          {renderContextMenuContent()}
          {/*
          <ul>
            <li onClick={handleEdit}>Edit</li>
            <li onClick={handleRename}>Rename</li>
            <li onClick={handleDelete}>Delete</li>
            <li onClick={handleSave}>Save</li>
          </ul>
        */}
        </div>
      )}
    </div>
  );
};

export default Dashboard;

